import React from 'react';
import { Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import type { PreviewGroup } from '../types';
import {
  InfoCardStyled,
  CardHeaderBandStyled,
  CardIconCircleStyled,
  CardBodyStyled,
  CountRowStyled,
  CountLabelStyled,
  CountValueStyled,
} from '../FileUploadCleanupPage.styles';

type PreviewCardProps = { group: PreviewGroup };

export const PreviewCard = ({ group }: PreviewCardProps) => (
  <InfoCardStyled elevation={0}>
    <CardHeaderBandStyled bandcolor={group.color}>
      <CardIconCircleStyled bandcolor={group.color}>
        <FontAwesomeIcon icon={group.icon} />
      </CardIconCircleStyled>
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: '0.72rem',
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          color: group.color,
          lineHeight: 1.2,
        }}
      >
        <FormattedMessage id={group.titleId} />
      </Typography>
    </CardHeaderBandStyled>
    <CardBodyStyled>
      {group.items.map(item => (
        <CountRowStyled key={item.labelId}>
          <CountLabelStyled>
            <FormattedMessage id={item.labelId} />
          </CountLabelStyled>
          <CountValueStyled accent={group.color}>{item.count}</CountValueStyled>
        </CountRowStyled>
      ))}
    </CardBodyStyled>
  </InfoCardStyled>
);
